export const updateDIFMConsultInCart =
  (isRequested) =>
  async (dispatch, getState, { api }) =>
    api.updateDIFMConsultInCart(isRequested);
